import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { withStateHandlers, withHandlers, compose } from 'recompose'

import ChooseSurveyTypeModalContainer from 'organisms/Admin/Surveys/ChooseSurveyTypeModal'
import ChooseHelpdeskModal from 'containers/Admin/Surveys/ChooseHelpdeskModal'
import constants from 'config/constants'
import { Condition } from 'components/Condition'
import { AllowPermission } from 'shared/components/AllowPermission'
import { Button } from 'semantic-ui-react'

function NewSurveyButton({ onClickCreateNewSurvey, isCreate }) {
  useEffect(() => {
    isCreate && onClickCreateNewSurvey()
  }, [isCreate, onClickCreateNewSurvey])

  return (
    <AllowPermission permission={constants.permissions.manageSurveys}>
      <Button id="create-survey-btn" primary onClick={onClickCreateNewSurvey}>
        <i className="icon far fa-plus" /> New survey
      </Button>
    </AllowPermission>
  )
}

NewSurveyButton.propTypes = {
  onClickCreateNewSurvey: PropTypes.func,
  isCreate: PropTypes.bool,
}

const enhance = compose(
  withRouter,
  withStateHandlers(
    {
      isModalOpened: { chooseSurveyType: false, chooseHelpdesk: false },
    },
    {
      showChooseSurveyTypeModal: () => () => ({
        isModalOpened: { chooseSurveyType: true, chooseHelpdesk: false },
      }),
      closeModal: () => () => ({
        isModalOpened: { chooseSurveyType: false, chooseHelpdesk: false },
      }),
    }
  ),
  withHandlers({
    onModalClosed: (props) => () => {
      props.history.replace({
        search: null,
      })
      props.closeModal()
    },
    onClickCreateNewSurvey: (props) => () => {
      props.showChooseSurveyTypeModal()
    },
  })
)

export const CreateNewSurveyModal = enhance(
  ({
    isModalOpened,
    onModalClosed,
    onClickCreateNewSurvey,
    canCreateSurvey,
    isCreate,
    workspaceToken,
  }) => {
    return (
      <React.Fragment>
        <Condition.True condition={canCreateSurvey}>
          <NewSurveyButton onClickCreateNewSurvey={onClickCreateNewSurvey} isCreate={isCreate} />
        </Condition.True>
        {isModalOpened.chooseHelpdesk ? (
          <ChooseHelpdeskModal
            handleClose={onModalClosed}
            isOpenModal={isModalOpened.chooseHelpdesk}
            workspaceToken={workspaceToken}
          />
        ) : (
          <ChooseSurveyTypeModalContainer
            handleClose={onModalClosed}
            isOpenModal={isModalOpened.chooseSurveyType}
            workspaceToken={workspaceToken}
          />
        )}
      </React.Fragment>
    )
  }
)

CreateNewSurveyModal.propTypes = {
  canCreateSurvey: PropTypes.bool.isRequired,
  isCreate: PropTypes.bool.isRequired,
  workspaceToken: PropTypes.string.isRequired,
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/Admin/Surveys/CreateNewSurveyModal/index.js